import type { InterventionSectionMenuTreeItem } from "./intervention-menu-tree.type";
import type {
  InterventionSectionItem,
  InterventionSectionObservation,
} from "@/modules/intervention/intervention-section";

import {
  getInterventionSectionAsset,
  getInterventionSectionObservations,
  getInterventionSectionParams,
  getInterventionSectionSections,
  isDynamicSection,
  isLoopOnChildrenSection,
} from "@/modules/intervention/intervention-section";

export const getMenuTreeItems = (
  sections?: InterventionSectionItem[]
): InterventionSectionMenuTreeItem[] => {
  if (!sections?.length) return [];
  return sections.map(getMenuTreeItem);
};

const getMenuTreeItem = (
  section: InterventionSectionItem
): InterventionSectionMenuTreeItem => {
  const treeItem: InterventionSectionMenuTreeItem = {
    key: getMenuTreeItemKey(section),
    title: `${section.name}`,
    data: section,
  };

  // We display section's asset name (instead of section's name)
  // only if `section.is_loop_on_children = true`
  const asset = getInterventionSectionAsset(section);
  if (asset && isLoopOnChildrenSection(section)) {
    treeItem.title = asset.name;
  }

  const children = getMenuTreeItemChildren(section);

  if (!children.length) return treeItem;

  return {
    ...treeItem,
    children: getMenuTreeItems(children),
  };
};

const getMenuTreeItemChildren = (section: InterventionSectionItem) => {
  const sections = getInterventionSectionSections(section);
  let observations: InterventionSectionObservation[] = [];

  // We display section's observations only if `section.is_dynamic = true`
  if (isDynamicSection(section)) {
    observations = getInterventionSectionObservations(section);
  }

  // We always display observations before sections
  return [...observations, ...sections];
};

export const getMenuTreeItemKey = (section: InterventionSectionItem) => {
  const prefix = "intervention-menu-item";

  const { layoutIndex, assetId, observationId } =
    getInterventionSectionParams(section);

  if (observationId) return `${prefix}-observation-${observationId}`;

  let key = `${prefix}-section-${layoutIndex}`;
  if (assetId) key += `-${assetId}`;

  return key;
};
